/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowCircleUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 12c0 5.514-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2s10 4.486 10 10zm-2 0c0-4.412-3.59-8-8-8s-8 3.588-8 8 3.59 8 8 8 8-3.588 8-8zm-2.293.293-1.414 1.414L13 10.414V17h-2v-6.586l-3.293 3.293-1.414-1.414L12 6.586z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArrowCircleUp as ArrowCircleUp };
